<template>
  <base-nav
    container-classes="container-fluid"
    class="navbar-top border-bottom navbar-expand"
    :class="$route.meta.navbarClasses ? $route.meta.navbarClasses : 'bg-pink navbar-dark'"
    type=""
  >

    <!-- Navbar links -->
    <b-navbar-nav class="align-items-center ml-md-auto">
      <!-- This item dont have <b-nav-item> becouse they add class 'nav-link' which is not needed here -->
      <li class="nav-item d-xl-none">
        <!-- Sidenav toggler -->
        <div class="pr-2 sidenav-toggler sidenav-toggler-dark"
             @click="toggleSidebar">
          <div class="sidenav-toggler-inner">
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
            <i class="sidenav-toggler-line"></i>
          </div>
        </div>
      </li>

    </b-navbar-nav>


    <b-navbar-nav v-if="user" class="align-items-center ml-auto ml-md-0">
      <base-dropdown menu-on-right
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <b-media no-body class="align-items-center">
                  <span class="avatar avatar-sm rounded-circle">
                    <img v-if="user.photoURL" :src="user.photoURL">
                    <i v-else class="fas fa-user"></i>
                  </span>
            <b-media-body class="ml-2 d-none d-sm-block">
              <span v-if="user.name" class="mb-0 text-sm  font-weight-bold">{{ user.name }}</span>
              <span v-else-if="user.email" class="mb-0 text-sm  font-weight-bold">{{ user.email }}</span>              
            </b-media-body>
          </b-media>
        </a>

        <template>

          <b-dropdown-header class="noti-title">
            <h6 class="text-overflow m-0">Menú</h6>
          </b-dropdown-header>
          <b-dropdown-item v-if="user.id" :to="{ name: 'Profile', params: { user_id: user.id} }">
            <i class="fas fa-user-circle"></i>
            <span>Ajustes</span>
          </b-dropdown-item>

          <div class="dropdown-divider"></div>
          <b-dropdown-item @click="logout">
            <i class="fas fa-sign-out-alt"></i>
            <span>Salir</span>
          </b-dropdown-item>

        </template>
      </base-dropdown>
    </b-navbar-nav>
  </base-nav>
</template>
<script>
import { CollapseTransition } from 'vue2-transitions';
import { BaseNav, Modal } from '@/components';
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  props: ['user'],
  components: {
    CollapseTransition,
    BaseNav,
    Modal
  },
  computed: {
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    isRTL() {
      return this.$rtl.isRTL;
    }
  },
  data() {
    return {
      activeNotifications: false,
      showMenu: false,
      searchModalVisible: false,
      searchQuery: ''
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      firebase.auth().signOut().then(() => {
        // this.$router.push({ name: 'Login' })
      })
    }
  }
}
</script>
<style scoped>
.top-navbar {
  top: 0px;
}
</style>
